import { render, staticRenderFns } from "./AtencionValidacionComentario.vue?vue&type=template&id=d610f1e4"
import script from "./AtencionValidacionComentario.vue?vue&type=script&lang=js"
export * from "./AtencionValidacionComentario.vue?vue&type=script&lang=js"
import style0 from "./AtencionValidacionComentario.vue?vue&type=style&index=0&id=d610f1e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports